import Prismic from '@prismicio/client'

import Client from './Client'

export default new Client(process.env.NEXT_PUBLIC_PRISMIC_API)

export const Predicates = Prismic.Predicates
